import styled from "styled-components";

export default function CardBone() {
  return (
    <CardWrap>
      <div className="CardFront">
        <div className="ImgWrap"></div>
        <div className="TextWrap"></div>
        <div className="Bottom">
          <div className="TagWrap"></div>
        </div>
      </div>
    </CardWrap>
  );
}

const CardWrap = styled.div`
  position: relative;
  width: 300px;
  height: 400px;
  background-color: white;
  z-index: 1;
  .CardFront {
    position: relative;
    width: 300px;
    height: 400px;
    border: 1px solid #314af3;
    background-color: white;
    overflow: hidden;
    padding: 10px;
    z-index: 10;
    .ImgWrap {
      width: 280px;
      height: 280px;
      margin-bottom: 10px;
      background-color: white;

      border: 1px solid #314af3;
    }
    .TextWrap {
      margin-bottom: 14px;
    }
    .Bottom {
      position: absolute;
      bottom: 8px;
      right: 8px;
      display: flex;
      justify-content: end;
      align-items: end;
      .TagWrap {
      }
    }
  }
`;
